import React from 'react';
import PublicLayout from './PublicLayout';

const Support = () => {
  return (
    <PublicLayout>
      <div className="bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Support</h1>

            <div className="prose max-w-none">
              <p className="text-gray-600 mb-8">
                For any assistance or inquiries, please contact our support team using the information below.
              </p>

              <div className="grid md:grid-cols-2 gap-8">
                {/* Business Support */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-lg border border-blue-100">
                  <div className="flex items-center mb-4">
                    <div className="bg-blue-600 rounded-full p-3 mr-4">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6" />
                      </svg>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800">Business Support</h2>
                  </div>

                  <div className="space-y-3">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Contact Person</p>
                      <p className="font-medium text-gray-800">Julie Vidal</p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600 mb-1">Email</p>
                      <a
                        href="mailto:julie.vidal@loreal.com"
                        className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                      >
                        julie.vidal@loreal.com
                      </a>
                    </div>

                    <div className="pt-2">
                      <p className="text-sm text-gray-600">
                        For business-related inquiries, process questions, and general support.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Technical Support */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
                  <div className="flex items-center mb-4">
                    <div className="bg-green-600 rounded-full p-3 mr-4">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800">Technical Support</h2>
                  </div>

                  <div className="space-y-3">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Contact Person</p>
                      <p className="font-medium text-gray-800">Guillaume Potier</p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600 mb-1">Email</p>
                      <a
                        href="mailto:gpotier@globe-groupe.com"
                        className="text-green-600 hover:text-green-800 font-medium transition-colors"
                      >
                        gpotier@globe-groupe.com
                      </a>
                    </div>

                    <div className="pt-2">
                      <p className="text-sm text-gray-600">
                        For technical issues, bug reports, and system-related problems.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Information */}
              <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">Response Times</h3>
                <div className="grid md:grid-cols-2 gap-4 text-sm text-gray-600">
                  <div>
                    <strong>Business Support:</strong> 24-48 hours during business days
                  </div>
                  <div>
                    <strong>Technical Support:</strong> 4-8 hours for critical issues, 24-48 hours for general issues
                  </div>
                </div>
              </div>

              {/* Contact Tips */}
              <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h4 className="font-semibold text-blue-800 mb-2">💡 Tips for Faster Support</h4>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>• Include your user ID and specific error messages</li>
                  <li>• Describe the steps that led to the issue</li>
                  <li>• Attach screenshots if applicable</li>
                  <li>• Specify if the issue is urgent or blocking your work</li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <button
                onClick={() => window.location.href = '/'}
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
              >
                Back to App
              </button>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Support;
